import { render, staticRenderFns } from "./sbxxglDetail2.vue?vue&type=template&id=bca6595c&scoped=true&"
import script from "./sbxxglDetail2.vue?vue&type=script&lang=js&"
export * from "./sbxxglDetail2.vue?vue&type=script&lang=js&"
import style0 from "./sbxxglDetail2.vue?vue&type=style&index=0&id=bca6595c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca6595c",
  null
  
)

export default component.exports